import React from 'react'
import { DatePicker } from 'antd'
const DatePickerField = ({ label,
    name,
    onChange,
    showTime,
    value,
    format,
    disabledDate,
    allowClear,
    placeholder,
    style,
    onKeyDown,
    className,
    max
}) => {
    return (
        <div className="input-block mb-3">
            {label && <label className={className}>{label}</label>}{label && <br/> }
            <DatePicker
                showTime={showTime}
                name={name}
                value={value}
                format={format}
                disabledDate={disabledDate}
                onChange={onChange}
                allowClear={allowClear}
                placeholder={placeholder}
                style={style}
                onKeyDown={onKeyDown}
            />
        </div>
    )
}
 
export default DatePickerField
 